import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const movieDatabase = {
    name: 'Movie Database',
    slug: 'movie-database',
    description: 'Online database related to films, movies, trailers, television programs, artists, producers, ratings, reviews, statistics, awards, upcoming festivals etc.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/movie-database/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by Freepik'
        }
    },
    prominentColor: 'rgb(185,46,23)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/movie-database/studio.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by vectorpocket / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/movie-database/studio2.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/movie-database/studio3.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/movie-database/studio4.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/movie-database/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Role',
            description: 'Back End developer',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['PHP', 'CakePHP', 'Memcached', 'MySQL'],
        } as PieceUnorderedList,
    ],
};

export default movieDatabase;


// WEBPACK FOOTER //
// ./src/store/portfolio/movie-database.tsx